import { Modal } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";
import { SecondaryText } from "@/components/Typography/Styled";

export const StyledISIModal = styled(Modal)`
    .ant-modal-content {
        padding: 0 !important;
    }
`;

export const StyledISIBlock = styled(FlexContainer)`
    width: 100%;
    margin-top: 16px;
    padding: 12px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-left: 1px solid ${({ theme }) => theme.colors.warning};
    background-color: ${({ theme }) =>
        theme.collapseHeaderBackground} !important;

    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StyledISISum = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.itemBorder} !important;
    text-align: left;
`;
